<!-- File input -->
<tcc-file-input
  [placeholder]="placeholder"
  [disabled]="disabled"
  [filter]="filter"
  (fileSelect)="onFileSelect($event)">
</tcc-file-input>

